// extracted by mini-css-extract-plugin
export default {"backButton":"UdWf6PhyQfD05D_AwLxn"};